import { TransactionColumn } from "./TransactionColumn";
import { TransactionColumnSizer } from "./TransactionColumnSizer";
import { TransactionColumnFilterDescription } from "./TransactionColumnFilterDescription";
import { DefaultTransactionColumnHeader } from "./DefaultTransactionColumnHeader";

export function TransactionColumnHeaderDescription(): JSX.Element {
  return (
    <TransactionColumnSizer column={TransactionColumn.DESCRIPTION}>
      <DefaultTransactionColumnHeader
        column={TransactionColumn.DESCRIPTION}
        text={"Description"}
        FilterType={TransactionColumnFilterDescription}
      />
    </TransactionColumnSizer>
  );
}
